// src/pages/B2B/event-reports/api/useDeleteEventReport.ts
import { useCallback, useState } from 'react';
import type { Env } from '@/pages/Admin/shared';
import { useAdminApi } from '@/pages/Admin/shared/adminApi';

export function useDeleteEventReport(env: Env) {
  const { request } = useAdminApi();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const remove = useCallback(
    async (id: string): Promise<boolean> => {
      setLoading(true);
      setError(null);
      try {
        await request({ env, path: `/admin/event-reports/${id}`, method: 'DELETE' });
        return true;
      } catch (e: any) {
        setError(e?.message ?? 'Delete failed');
        return false;
      } finally {
        setLoading(false);
      }
    },
    [request, env],
  );

  return { remove, loading, error };
}
